import React from 'react';

interface FilterBarProps {
  filters: Record<string, string>;
  onFilterChange: (key: string, value: string) => void;
}

const filterFields: { key: string; label: string; options?: string[] }[] = [
  { key: 'appId', label: 'App' },
  { key: 'stackId', label: 'Stack' },
  { key: 'accountId', label: 'Account' },
  { key: 'region', label: 'Region' },
  { key: 'priority', label: 'Priority', options: ['CRITICAL', 'HIGH', 'MEDIUM', 'LOW'] },
  { key: 'ackState', label: 'Ack State', options: ['unacked', 'acked'] },
];

const FilterBar: React.FC<FilterBarProps> = ({ filters, onFilterChange }) => {
  const hasAny = Object.values(filters).some(Boolean);
  return (
    <div className="card-padded mb-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {filterFields.map((field) => (
          <div key={field.key}>
            <label className="label" htmlFor={`filter-${field.key}`}>
              {field.label}
            </label>
            {field.options ? (
              <select
                id={`filter-${field.key}`}
                className="select"
                value={filters[field.key] || ''}
                onChange={(e) => onFilterChange(field.key, e.target.value)}
              >
                <option value="">All</option>
                {field.options.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            ) : (
              <input
                id={`filter-${field.key}`}
                type="text"
                className="input"
                placeholder="All"
                value={filters[field.key] || ''}
                onChange={(e) => onFilterChange(field.key, e.target.value)}
              />
            )}
          </div>
        ))}
      </div>
      {hasAny && (
        <div className="mt-3 flex justify-end">
          <button
            type="button"
            className="btn-ghost text-xs"
            onClick={() => filterFields.forEach((f) => onFilterChange(f.key, ''))}
          >
            Clear filters
          </button>
        </div>
      )}
    </div>
  );
};

export default FilterBar;
